export default "__VITE_PUBLIC_ASSET__4c4d1f9e__"